(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const height = this.offsetHeight || this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

/* Prime Review レビュー→コメント 文字置換 */
(() => {
  const ROOT_SELECTOR = '#shopify-block-mxpr_product_review_block'; // ←Prime Reviewの親要素に合わせて変更
  const MAP = [
    ['最初のレビューを書く', '最初のコメントを書く'],
    ['レビュー', 'コメント'],
  ];

  const replaceTextNodes = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      let v = node.nodeValue;
      if (!v) return;
      MAP.forEach(([from, to]) => {
        // 完全一致ではなく部分置換（必要なら正規表現に）
        v = v.split(from).join(to);
      });
      node.nodeValue = v;
    });
  };

  const boot = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    // 初回
    replaceTextNodes(root);

    // Ajax描画・タブ切替・ページネーション等に追従
    const mo = new MutationObserver(() => replaceTextNodes(root));
    mo.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-lp"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".aboutSwiper", {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: true,
      speed: 4000,
      allowTouchMove: false,
      autoplay: {
          delay: 0,
          disableOnInteraction: false,
      },
      breakpoints: {
          320: {
              slidesPerView: 3,
              spaceBetween: 10,
          },
          480: {
              slidesPerView: 5.8,
              spaceBetween: 10,
          },
          640: {
              slidesPerView: 5.8,
              spaceBetween: 10,
          },
          1024: {
              slidesPerView: 5.9,
              spaceBetween: 30,
          },
      },
      pagination: {
          el: ".aboutSwiper .aboutSwiper__pagination",
          clickable: true,
      },
  });

  /* FAQ */
  const questions = document.getElementsByClassName("faq__question");

  for (const faq__question of questions) {
  faq__question.addEventListener("click", function () {
    this.classList.toggle("active");
    const icon = this.querySelector(".faq__icon");
    if (icon) {
      icon.classList.toggle("active");
    }

    const panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
  }

  } catch(e) { console.error(e); }
})();
})();
